import styled from 'styled-components';
import { PostBox } from 'pages/home/Home.style';

const ProfileContainer = styled.div`
  // padding: 8px 0px 8px;
  ${PostBox} {
    padding: 8px;
    margin-top: 4px;
  }
  .profile-header {
    display: flex;
    align-items: center;
    width: 100%;
    background: ${({ theme }) => theme.Bg1};
    height: 20px;
    position: sticky;
    top: 55px;
    z-index: 1;
    padding: 12px 0;
    padding-bottom: 8px;
    .close-icon-container {
      margin-left: 8px;
    }
    .user-name {
      padding-left: 8px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors[2]};
    }
  }
  .MuiTabs-root {
    margin: 0 6px;
  }
`;

const AddMoreStyle = styled.div`
  .add-list-sec-div {
    display: flex;
    > div {
      padding-left: 12px;
    }
  }
  .cmy-list-parent-div {
    margin-top: 8px;
  }
  .ql-container {
    height: 180px;
  }
  .inputContainer,
  .imageUpload,
  .text-editor {
    margin-top: 12px;
  }
`;

const PersonalContainer = styled.div`
  .personal-list {
    >div {
      margin-top: 4px;
    }
    .cmy-name-url {
      width: fit-content;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

const PStrengthPopOver = styled.div`
  padding: 8px;
  font-size: 14px;
  width: 150px;
  .progress-details {
    display: flex;
    justify-content: space-between;
    height: 24px;
    svg {
      width: 20px;
      height: 20px;
      fill: #08979c;
    }
  }
`

export {
  ProfileContainer,
  PersonalContainer,
  AddMoreStyle,
  PStrengthPopOver
};
